// Real-time Collection Hook for React
// Subscribes to a collection and updates in real-time
// Generated by @firebase-setup agent

import { useState, useEffect } from 'react';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig.js';

/**
 * Hook to subscribe to a collection in real-time
 * @param {string} collectionName - Name of the collection
 * @param {Array} queryConstraints - Optional Firestore query constraints (where, orderBy, limit, etc.)
 * @returns {{data: Array, loading: boolean, error: string|null}}
 */
export const useCollection = (collectionName, queryConstraints = []) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!collectionName) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const collectionRef = collection(db, collectionName);
    const q = query(collectionRef, ...queryConstraints);

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const documents = [];
        querySnapshot.forEach((doc) => {
          documents.push({ id: doc.id, ...doc.data() });
        });
        setData(documents);
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching collection:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [collectionName, JSON.stringify(queryConstraints)]);

  return { data, loading, error };
};

export default useCollection;
